import { atom } from 'jotai';

export const filterAtom = atom({
	selectedCities: [],
	cities: [], // Fetched cities
});
